import { render } from "./FormDescriptionComponent.vue?vue&type=template&id=a10376ee"
import script from "./FormDescriptionComponent.vue?vue&type=script&lang=js"
export * from "./FormDescriptionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__